import { Component, OnInit } from '@angular/core';
import { LibellesService } from 'src/app/core/libelles.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { InputComponent } from '../../input/input.component';
import { FiltreService } from 'src/app/shared/filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-checkbox-input-keypad',
  templateUrl: './checkbox-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class CheckboxInputKeypadComponent extends InputComponent implements OnInit {
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}
